import React from 'react';
import { ScheduleTable } from '../../components/ScheduleTable';
import { LocationBlock } from '../../components/LocationBlock';
export function TaekwondoNearMeScheduleLocation() {
  return <section className="py-24 bg-off-white" data-id="element-3434">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3435">
        <div className="grid lg:grid-cols-2 gap-16" data-id="element-3436">
          <div data-id="element-3437">
            <h2 className="text-4xl text-ink mb-8" data-id="element-3438">Class Times</h2>
            <ScheduleTable data-id="element-3439" />
          </div>
          <div data-id="element-3440">
            <h2 className="text-4xl text-ink mb-8" data-id="element-3441">
              Taekwondo Classes in Farmington Hills, MI
            </h2>
            <LocationBlock data-id="element-3442" />
          </div>
        </div>
      </div>
    </section>;
}